import { VideoTexture } from 'three';

import { GetBy } from '../core/Element';
import Image from './Image';

export default class Video extends Image {
    constructor(opts = {}) {
        super(opts);
    }

    loadTexture() {
        const image = this._target.dataset.poster;
        this._textureLoader.load(
            image,
            texture => {
                if (this.isVideoLoaded) return;
                this.texture = texture;
                this.material.uniforms.texture1.value = texture;
            },
            undefined,
            // onError callback
            function (err) {
                console.error('An error happened.', err);
            });

        const video = GetBy.tag('video', this._target)[0];
        const _play = () => {
            this.isVideoLoaded = true;
            video.removeEventListener('play', _play);

            this.texture = new VideoTexture(video);
            this.material.uniforms.texture1.value = this.texture;
        }
        video.addEventListener('play', _play);

        const mask = this._target.dataset.mask;
        if (mask) {
            this._textureLoader.load(
                mask,
                texture => {
                    this.material.uniforms.mask.value = texture;
                },
                undefined,
                // onError callback
                function (err) {
                    console.error('An error happened.', err);
                });
        }
    }
}
